export enum AccountPurposeEnum {
  PersonalUse = 'Personal Use',
  Education = 'Education',
  Business = 'Business',
}
